module.exports = import("https://esm.sh/@tiptap/extension-paragraph@2.4.0");;